// Theme entry point. The SCSS is imported here so Vite compiles it and
// extracts it to dist/app.css alongside the bundled dist/app.js.
import './app.scss';

// jQuery is provided globally by WordPress (enqueued as a dependency), so it
// is referenced as a global rather than imported/bundled.
jQuery(function ($) {

  // Sliders are powered by Splide (loaded as a global via CDN in header.php).
  // Guarded so pages/environments without Splide still load cleanly.
  if (typeof Splide !== 'undefined') {
    document.querySelectorAll('.testimonial-slider').forEach(function (el) {
      new Splide(el, {
        type:         'loop',
        perPage:      2,
        perMove:      1,
        speed:        300,
        autoplay:     true,
        interval:     7500,
        arrows:       false,
        pagination:   false,
        pauseOnHover: true,
        breakpoints: {
          480: { perPage: 1 }
        }
      }).mount();
    });

    document.querySelectorAll('.gallery-slider').forEach(function (el) {
      new Splide(el, {
        type:         'loop',
        perPage:      4,
        perMove:      1,
        gap:          '1rem',
        autoplay:     true,
        interval:     4500,
        arrows:       false,
        pagination:   false,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          480: { perPage: 1 }
        }
      }).mount();
    });
  }

  // The header is position:fixed, so pad the body by the header's measured
  // height to push all page content below it. Recomputed on resize so it
  // stays correct as the header reflows across breakpoints.
  function offsetBodyForHeader() {
    var headerHeight = $('.header-wrapper').outerHeight();
    $('body').css({ "padding-top": headerHeight });
    // The home-page hero is full-bleed behind the fixed header, so cancel the
    // body padding for it by pulling it back up the same amount.
    $('.hero').css({ "margin-top": -headerHeight });
  }
  offsetBodyForHeader();
  $(window).on('resize', offsetBodyForHeader);

	$(window).scroll(function() {
		if($(window).scrollTop() > 100){
		    $('.header-wrapper').addClass('header-modify')
		} else {
			$('.header-wrapper').removeClass('header-modify')
		}
	});

$('.products-tab').on('click', function(e) {
    e.preventDefault();
    console.log('Before adding class:', $('.dropmenu').hasClass('menu-show'));
    $('.dropmenu').addClass('menu-show menu-active');
    console.log('After adding class:', $('.dropmenu').hasClass('menu-show'));

    // Check again after a small delay
    setTimeout(function() {
        console.log('After 100ms:', $('.dropmenu').hasClass('menu-show'));
    }, 100);

    $('.nav-closer').show();
    return false;
});

jQuery.each(jQuery('.products-tab').data("events") || {}, function(i, event) {
    jQuery.each(event, function(j, h) {
        console.log('Event handler found:', i, h.handler);
    });
});

	$('.nav-closer').mouseover(function() {
		$('.dropmenu').removeClass('menu-show')
		$('.nav-closer').hide();
	})

	$('.burger-menu').on('click', function() {
		if (!$('.mobile-menu').hasClass('active-menu')) {
			$('.mobile-menu').addClass('active-menu')
			$('burger-menu').addClass('burger-active')
		} else {
			$('.mobile-menu').removeClass('active-menu')
		}
	})
});
